module.exports = __webpack_public_path__ + "files/fe5544b39e6d00e35a0d892acf9c381a.svg";